import React, { useEffect, useState } from "react"

import { validatorTypes } from "../../hooks/forms/forms"
import useCaptcha from "../../hooks/forms/useCaptcha"
import useInput from "../../hooks/forms/useInput"
import { sendUnsubscribeForm } from "../../service/rest"
import Form from "../Form/Form"
import Input from "../Form/Input"
import Submit from "../Form/Submit"
import s from "./UnsubscribeModal.module.scss"

const CAPTCHA_ACTION = "form_burgerking_unsubscribe"

export default function UnsubscribeModal({ i18n, langCode, onClose }) {
  const [loading, setLoading] = useState(false)
  const [errorsVisible, setErrorsVisible] = useState(false)
  const [succeeded, setSucceeded] = useState(false)
  const [submitError, setSubmitError] = useState(false)

  const captcha = useCaptcha()
  const fields = {
    email: useInput({
      initialValue: "",
      errorsVisible,
      required: true,
      validatorType: validatorTypes.email,
    }),
  }

  useEffect(() => {
    document.documentElement.classList.add("open-popup")
    return () => document.documentElement.classList.remove("open-popup")
  }, [])

  return (
    <div className={s.overlay} onClick={handleOverlayClick}>
      <div className={s.modal} role="dialog" aria-modal="true">
        <button
          aria-label="Close"
          className={s.closeButton}
          onClick={onClose}
          type="button"
        >
          ×
        </button>

        {succeeded ? (
          <div className={s.success}>
            <h2 className={s.successTitle}>{i18n.successTitle}</h2>
            <p className={s.successText}>{i18n.successText}</p>
            <button className={s.doneButton} onClick={onClose} type="button">
              OK
            </button>
          </div>
        ) : (
          <>
            <div className={s.emailIcon}>✉</div>
            <h2 className={s.title}>{i18n.title}</h2>
            <p className={s.subtitle}>{i18n.subtitle}</p>
            <Form className={s.form} onSubmit={handleSubmit}>
              <Input
                label={i18n.emailLabel}
                name="email"
                placeholder={i18n.emailPlaceholder}
                type="email"
                {...fields.email.props}
              />
              <Submit
                disabled={loading}
                value={loading ? i18n.sendingLabel : i18n.submitLabel}
              />
              {submitError && (
                <p className={s.submitError}>{i18n.submitErrorText}</p>
              )}
            </Form>
            <button className={s.cancelButton} onClick={onClose} type="button">
              {i18n.cancelLabel}
            </button>
            <p className={s.footerText}>{i18n.footerText}</p>
          </>
        )}
      </div>
    </div>
  )

  function handleOverlayClick(e) {
    if (e.target === e.currentTarget) onClose()
  }

  function handleSubmit(e) {
    e.preventDefault()
    if (isFormValid()) {
      submitForm()
    } else {
      setErrorsVisible(true)
    }
  }

  function isFormValid() {
    return Object.values(fields).every((f) => f.valid)
  }

  async function submitForm() {
    setLoading(true)
    setSubmitError(false)
    try {
      const token = await captcha.getToken(CAPTCHA_ACTION)
      await sendUnsubscribeForm({
        email: fields.email.value,
        captchaToken: token,
        captchaAction: CAPTCHA_ACTION,
        captchaUserId: fields.email.value,
      })
      setSucceeded(true)
    } catch {
      setSubmitError(true)
    } finally {
      setLoading(false)
    }
  }
}
